import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import cx from 'classnames';

import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@common/components/modal';
import Dropdown from '@common/containers/fields/Dropdown';
import { shallowIncludes } from '@common/utils/array';
import ActionsButton from '@common/components/ActionsButton';
import { Loading } from '@common/components/loading';
import { Button } from '@common/components/Button';
import { Header } from '@common/components/Header';
import { Table, scrollToStart } from '@common/components/Table';
import { Flex } from '@common/components/Flex';
import { OrderPatientLinking } from './components/OrderPatientLinking';
import { Documents } from './components/Documents';
import { getPatients, resetPatients, getPatientsFilters, getPatientsFolderFields, getPatientsFolders, addColumnToPatientsTable, setPatientsColumnsWidth } from './actions/patients';
import {
    getOrders,
    linkOrderAndPatient,
    openDatasheet,
    openPedigree,
    openTestResults,
    getOrganizations,
    getOrganizationsAccessStatus,
    sendPedigreeToAmbry
} from './actions/orders';
import { getAppConfig } from '@common/utils/config';
import { compareDates } from '@common/utils/date';
import { getTestAttributes } from '@common/utils/tests';
import { ErrorIcon } from '@common/components/error-icon';
import { MessageBox } from '@common/components/MessageBox';

import './Orders.styles.scss';
import {InfoIcon} from "@common/components/info-icon";

const MODULE_NAME = 'Orders';

const RESULTS_TYPE = {
    docs: 1,
    default: 2,
};
const ORDERS_TYPE = {
    organization: 1,
    my: 0,
};
const loadItemsCount = 40;

class OrdersComponent extends React.Component {
    rootRef = React.createRef();
    appConfig = getAppConfig();
    resultsType;
    state = {
        loading: false,
        organizations: [],
        loading: false,
        organizations: [],
        activeOrder: undefined,
        loadingOrders: false,
        isOpenOrderPatientLinking: false,
        isOpenDocuments: false,
        orderUrl: '',
        loadOrdersMetadata: {
            pagination: {
                start: 0,
                size: loadItemsCount,
            },
            sorting: {},
            filtering: {
                vieworgorders: ORDERS_TYPE.my,
                profileId: ''
            }
        },
        messageProps: {
            header: '',
            text: '',
            show: false,
            confirmText: 'Ok',
            cancelText: '',
            size: 'small',
            onCustomOk: () => {},
        },
        organizationsAccess: [],
        searchKeyword: '',
    };

    componentDidMount() {
        this.props.getPatientsFilters();

        this.getOrganizations().then((organizations) => {
            const defaultOrganization = organizations.length ? organizations[0].id : undefined;

            if (defaultOrganization) {
                this.handleOrganizationChange(defaultOrganization);
            } else {
                this.loadOrders();
            }
        });

        getOrganizationsAccessStatus().then((organizationsAccess) => {
            this.setState((state) => ({ ...state, organizationsAccess }));
        });
    }

    getOrganizations = () => {
        return getOrganizations().then((organizations) => {
            this.setState((prevState) => ({
                ...prevState,
                organizations
            }));

            return organizations;
        });
    }

    loadOrders = (loadMetadata) => {
        const metadata = {
            ...this.state.loadOrdersMetadata,
            ...loadMetadata,
        };

        return this.props.getOrders({
            ...metadata,
            filtering: {
                ...metadata.filtering,
                searchKeyword: this.state.searchKeyword,
            },
        });
    }

    setLoadOrdersMetadata = (metadata) => {
        this.setState((x) => ({
            ...x,
            loadOrdersMetadata: {
                ...x.loadOrdersMetadata,
                ...metadata
            },
        }));
    }

    handleOrdersSearch = ({ searchKeyword }) => {
        this.setState((x) => ({ ...x, searchKeyword }), () => {
            const metadata = {
                pagination: {
                    ...this.state.loadOrdersMetadata.pagination,
                    start: 0,
                },
            };
    
            this.setLoadOrdersMetadata(metadata);
            this.loadOrders(metadata);
        });
    }

    handleOrganizationChange = async (profileId) => {
        const metadata = {
            pagination: {
                ...this.state.loadOrdersMetadata.pagination,
                start: 0,
            },
            filtering: {
                ...this.state.loadOrdersMetadata.filtering,
                profileId,
            }
        };

        try {
            this.setLoading(true);
            await this.loadOrders(metadata);
            scrollToStart(this.rootRef.current);
            this.setLoadOrdersMetadata(metadata);
        } catch (err) {
            console.error(err);
            
            let errorMessage = err?.entity || '';

            if (errorMessage.length > 200) {
                errorMessage = I18n.t('Failed to change organization');
            }

            this.setMessageProps({
                header: I18n.t('Operation Canceled'),
                content: <><ErrorIcon /> {errorMessage}</>,
                show: true,
                confirmText: 'Ok',
                onCustomOk: () => this.setMessageProps({ show: false }),
            });
        } finally {
            this.setLoading(false);
        }
    }

    setLoading = (loading) => {
        this.setState((x) => ({ ...x, loading }));
    }

    openOrderPatientLinking = () => {
        this.setState((state) => ({ ...state, isOpenOrderPatientLinking: true }));
    }

    closeOrderPatientLinking = () => {
        this.setState((state) => ({ ...state, isOpenOrderPatientLinking: false }));
    }

    openDocumentsDialog = () => {
        this.setState((state) => ({ ...state, isOpenDocuments: true }));
    }

    closeDocumentsDialog = async () => {
        this.setState((state) => ({ ...state, isOpenDocuments: false }));

        const metadata = {
            pagination: {
                ...this.state.loadOrdersMetadata.pagination,
                start: 0,
            },
        };

        try {
            this.setLoading(true);
            await this.loadOrders(metadata);
            scrollToStart(this.rootRef.current);
            this.setLoadOrdersMetadata(metadata);
        } finally {
            this.setLoading(false);
        }
    }

    setActiveOrder = (activeOrder) => {
        this.setState((state) => ({ ...state, activeOrder }));
    }

    handleOpenPedigree = (id) => {
        this.props.openPedigree(id);
    }

    handleOpenDatasheet = (id) => {
        this.props.openDatasheet(id);
    }

    handleRelinkAmbryOrder = (id, data) => {
        this.handleLinkAmbryOrder(data);
    }

    handleSendPedigreeToAmbry = (id, data) => {
        this.sendToAmbry(data);
    }

    handleOpenTestResults = (id) => {
        this.props.openTestResults(id);
    }

    handleLinkAmbryOrder = (order) => {
        this.setActiveOrder(order);
        this.openOrderPatientLinking();
    }

    sendToAmbry = async (order) => {
        this.setActiveOrder(order);
        const { sendPedigreeToAmbry } = this.props;
        const { loadOrdersMetadata } = this.state;

        await sendPedigreeToAmbry({
            orderId: order.orderId,
            profileId: loadOrdersMetadata.filtering.profileId
        });
        this.setMessageProps({
            header: I18n.t('Pedigree sent'),
            content: <><InfoIcon /> {I18n.t('Pedigree has been successfully sent')}</>,
            show: true,
            confirmText: 'Ok',
            onCustomOk: () => this.setMessageProps({ show: false }),
        });
    }

    openDocuments = (order, resultsType) => {
        this.resultsType = resultsType;
        this.setActiveOrder(order);
        this.openDocumentsDialog();
    }

    handleOpenResultsDocuments = (order) => () => {
        this.openDocuments(order, RESULTS_TYPE.docs);
    }

    handleOpenResultsDefault = (order) => () => {
        this.openDocuments(order, RESULTS_TYPE.default);
    }

    handleLinkPatient = async (patient) => {
        const { linkOrderAndPatient } = this.props;
        const { activeOrder } = this.state;
        const { loadOrdersMetadata } = this.state;

        await linkOrderAndPatient({
            newGlobalId: patient.globalId,
            oldGlobalId: activeOrder.globalId || undefined,
            orderId: activeOrder.orderId,
            profileId: loadOrdersMetadata.filtering.profileId,
        });
        this.loadOrders();
    }

    get columns() {
        const actions = [
            { label: I18n.t('Open Pedigree'), onClick: this.handleOpenPedigree  },
            { label: I18n.t('Open Datasheet'), onClick: this.handleOpenDatasheet },
            { label: I18n.t('Re-Link Ambry'), onClick: this.handleRelinkAmbryOrder },
            { label: I18n.t('Send Pedigree to Ambry'), onClick: this.handleSendPedigreeToAmbry },
            { label: I18n.t('Open Test Results'), onClick: this.handleOpenTestResults },
        ];

        return [
            { 
                disableActions: true,
                resizable: false,
                sortable: false,
                Header: 'Actions', 
                Cell: ({ original }) => (
                    original.globalId
                        ? (
                            <ActionsButton 
                                id={original.orderId} 
                                data={original} 
                                menuItems={actions} 
                            />
                        )
                        : (
                            <button className="Orders__link-btn" onClick={() => this.handleLinkAmbryOrder(original)}>
                                <i className="fa fa-link" />
                            </button>
                        )
                ),
                minWidth: 65,
                className: 'table-actions-cell'
            },
            { 
                Header: 'Order ID', 
                accessor: 'orderId', 
                minWidth: 120, 
                Cell: ({ original }) => (
                    <Button 
                        variant="text"
                        text={original.orderId}
                        onClick={() => this.openOrderDetails(original.orderUrl)}
                    />
                ),
            },
            { Header: 'Patient', accessor: 'patientName', minWidth: 290 },
            { Header: 'DOB', accessor: 'patientDob', minWidth: 120, sortMethod: compareDates },
            { Header: 'Test', accessor: 'test', minWidth: 280 },
            { Header: 'Organization Name', accessor: 'organizationName', minWidth: 200 },
            { 
                Header: 'Status', 
                accessor: 'status', 
                minWidth: 120,
                Cell: ({ original: { status = '' } }) => {
                    const classConfig = {
                        'submitted': 'label-warning',
                        'unsubmitted': 'label-default',
                        'reported': 'label-success',
                    };

                    return <span className={`label ${classConfig[status.toLowerCase()] || 'label-default'}`}>{status}</span>
                }
            },
            { Header: 'Submitted', accessor: 'submissionDate', minWidth: 120, sortMethod: compareDates },
            { Header: 'Expected', accessor: 'expectedDate', minWidth: 120 },
            { 
                Header: 'Results', 
                accessor: 'results', 
                minWidth: 60,
                sortable: false,
                Cell: ({ original }) => {
                    const allFilesViewed = (original.results || []).every((x) => x.previouslyDownloaded);

                    return (
                        Boolean(original.results.length) && (
                            <button className={cx('Orders__docs-btn', { 'Orders__docs-btn--viewed': allFilesViewed })} onClick={this.handleOpenResultsDefault(original)}>
                                <i className="fa fa-file-text-o" />
                            </button>
                        )
                    );
                }
            },
            { 
                Header: 'Docs', 
                accessor: 'docs', 
                minWidth: 60,
                sortable: false,
                Cell: ({ original }) => {
                    const allFilesViewed = (original.docResults || []).every((x) => x.previouslyDownloaded);

                    return (
                        <button className={cx('Orders__docs-btn', { 'Orders__docs-btn--viewed': allFilesViewed })} onClick={this.handleOpenResultsDocuments(original)}>
                            <i className="fa fa-file-text-o" />
                        </button>
                    );
                }
            },
        ].map(({ sortable = true, Header, minWidth, ...otherProps }, i) => {
            return {
                sortable,
                minWidth,
                Header: I18n.t(Header),
                width: minWidth,
                ...otherProps,
            };
        });
    }

    get documents() {
        const { activeOrder } = this.state;
        const defaultValue = {
            ambryDocuments: [],
            clientDocuments: [],
        };

        if (!activeOrder) {
            return defaultValue;
        }

        const sourceConfig = {
            [RESULTS_TYPE.default]: activeOrder.results,
            [RESULTS_TYPE.docs]: activeOrder.docResults,
        };

        const source = sourceConfig[this.resultsType] || [];

        const ambryDocuments = source.filter(({ internallyUploaded }) => internallyUploaded);
        const clientDocuments = source.filter(({ internallyUploaded }) => !internallyUploaded);

        return {
            ambryDocuments,
            clientDocuments
        };
    }

    closeOrderDetails = () => {
        this.setState((state) => ({ ...state, orderUrl: '' }));
    }

    openOrderDetails = (orderUrl) => {
        this.setState((state) => ({ ...state, orderUrl }));
    }

    handleClinicTypeChange = async (e) => {
        const { id } = e.currentTarget.dataset;

        if (id == this.state.loadOrdersMetadata.filtering.vieworgorders) {
            return;
        }

        const metadata = {
            pagination: {
                ...this.state.loadOrdersMetadata.pagination,
                start: 0,
            },
            filtering: {
                ...this.state.loadOrdersMetadata.filtering,
                vieworgorders: id,
            }
        };

        this.setLoadOrdersMetadata(metadata);

        try {
            this.setLoading(true);
            await this.loadOrders(metadata);
            scrollToStart(this.rootRef.current);
        } finally {
            this.setLoading(false);
        }
    }

    setMessageProps = (props) => {
        this.setState((state) => ({
            ...state,
            messageProps: {
                size: 'small',
                ...props,
            },
        }));
    }

    get orderTypes() {
        return [
            {
                label: "Organization's orders",
                id: ORDERS_TYPE.organization,
            },
            {
                label: 'My Orders',
                id: ORDERS_TYPE.my,
            },
        ]
    }

    closeMessage = () => {
        this.setMessageProps({ show: false });
    }

    render() {
        const { orders, patients, getPatients, setPatientsTableColumnsSize, addColumnToPatientsTable, resetPatients, getPatientsFolders, getPatientsFolderFields, setPatientsColumnsWidth } = this.props;
        const config = this.appConfig.orders;
        const { activeOrder, isOpenOrderPatientLinking, isOpenDocuments, organizations, loading, loadOrdersMetadata, organizationsAccess } = this.state;
        const hasAccessToClinicsOrgs = organizationsAccess.find((x) => x.profileId == loadOrdersMetadata.filtering.profileId)?.accessToOrders;
        const selectedOrganizationLabel =
            organizations.find((x) => String(x.id) === String(loadOrdersMetadata.filtering.profileId))?.name
            || I18n.t('Select Organization');
        const organizationSelectWidthCh = Math.min(
            Math.max(selectedOrganizationLabel.length + 6, 28),
            90
        );

        return (
            <div className="Orders" ref={this.rootRef}>
                {isOpenOrderPatientLinking && (
                    <OrderPatientLinking 
                        patients={patients.list}
                        closeMessage={this.closeMessage}
                        showMessage={this.setMessageProps}
                        patientFilters={patients.listFilters}
                        order={activeOrder}
                        totalPatientsCount={patients.listCount}
                        getPatients={getPatients}
                        getFolders={getPatientsFolders}
                        getFields={getPatientsFolderFields}
                        onTableColumnsResize={setPatientsTableColumnsSize}
                        onLinkPatient={this.handleLinkPatient}
                        onClose={this.closeOrderPatientLinking}
                        onAddColumnToPatientsTable={addColumnToPatientsTable}
                        setPatientsColumnsWidth={setPatientsColumnsWidth}
                        resetPatients={resetPatients}
                    />
                )}
                {isOpenDocuments && (
                    <Documents 
                        ambryDocuments={this.documents.ambryDocuments}
                        clientDocuments={this.documents.clientDocuments}
                        patientName={activeOrder.patientName}
                        onClose={this.closeDocumentsDialog}
                    />
                )}
                <MessageBox
                    hideMessageBox={this.closeMessage}
                    {...this.state.messageProps}
                />
                <Modal
                    show={Boolean(this.state.orderUrl)}
                    animation={false}
                    backdrop="static"
                    bsClass="bootstrap modal"
                    dialogClassName="Order-details"
                    onEscapeKeyDown={this.closeOrderDetails}
                    onHide={this.closeOrderDetails}
                >
                    <ModalHeader closeButton onHide={this.closeOrderDetails}>
                    <ModalTitle id="lbl-order-status-results-header">
                        {I18n.t('AmbryPort View')}
                    </ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <iframe src={this.state.orderUrl} width="100%" height="100%" />
                    </ModalBody>
        
                    <ModalFooter>
                    <Button
                        id="btn-order-dialog-cancel"
                        text={I18n.t('Close')}
                        onClick={this.closeOrderDetails}
                    />
                    </ModalFooter>
                </Modal>
                <Header 
                    moduleName="Orders"
                    className="Orders__header"
                    withLiveSearch={config.liveSearchEnabled}
                    liveSearchDelay={config.liveSearchDelay}
                    onSearch={this.handleOrdersSearch}
                >
                    <Flex alignItems="center">
                        {loading && <Loading size={16} margin="0 10px" />}
                        {hasAccessToClinicsOrgs && (
                            <div className="btn-group">
                                {this.orderTypes.map((x) => (
                                    <Button
                                        key={x.id}
                                        text={I18n.t(x.label)}
                                        bsStyle={loadOrdersMetadata.filtering.vieworgorders == x.id ? 'primary' : undefined}
                                        {...getTestAttributes(MODULE_NAME, 'clinic', 'btn', x.id)}
                                        data-id={x.id}
                                        onClick={this.handleClinicTypeChange}
                                    />
                                ))}
                            </div>
                        )}
                        <div
                            className="Orders__header__organization-select"
                            style={{ width: `${organizationSelectWidthCh}ch` }}
                        >
                            <Dropdown
                                {...getTestAttributes(MODULE_NAME, 'organization', 'select')}
                                placeholder={I18n.t('Select Organization')}
                                selectedValue={loadOrdersMetadata.filtering.profileId}
                                searchable
                                options={organizations.map((x) => ({ value: x.id, label: x.name }))}
                                optionsHeight={100}
                                onValueChanged={this.handleOrganizationChange}
                            />
                        </div>
                    </Flex>
                </Header>
                <Table
                    infiniteScroll
                    disableAutoInit
                    noDataMessage={I18n.t('There no orders to display')}
                    config={{
                        data: orders.list,
                        columns: this.columns,
                    }}
                    loadItemsCount={loadItemsCount}
                    loadMetadata={{
                        filtering: loadOrdersMetadata.filtering
                    }}
                    itemsCount={orders.ordersTotalCount}
                    className="Orders__table"
                    onLoadData={this.loadOrders}
                    setLoadMetadata={this.setLoadOrdersMetadata}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ orders, patients }) => {
    return {
        orders,
        patients,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        openDatasheet,
        openPedigree,
        openTestResults,
        getPatientsFolderFields,
        getPatientsFolders,
        addColumnToPatientsTable,
        linkOrderAndPatient,
        sendPedigreeToAmbry,
        setPatientsColumnsWidth,
        resetPatients: (...args) => dispatch(resetPatients(...args)),
        getPatients: (...args) => dispatch(getPatients(...args)),
        setPatientsTableColumnsSize: () => {},
        getOrders: (...args) => dispatch(getOrders(...args)),
        getPatientsFilters: (...args) => dispatch(getPatientsFilters(...args)),
    };
};

export const Orders = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrdersComponent);
